import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';

export const AddRoleWrapper = styled(Box).attrs({
  width: '100%',
})``;

export const RolesHeader = styled(Text).attrs({
  size: 'header',
  fontWeight: 'semibold',
  m: 10,
  color: 'primaryText',
})``;

export const Description = styled(Text).attrs({
  size: 'normal',
  color: 'primaryText',
  margin: '0 10px 10px 10px',
})``;
